export default "__VITE_ASSET__55c54edb__"